import { render, staticRenderFns } from "./GInputLabel.vue?vue&type=template&id=4454a12f&scoped=true&"
import script from "./GInputLabel.vue?vue&type=script&lang=ts&"
export * from "./GInputLabel.vue?vue&type=script&lang=ts&"
import style0 from "./GInputLabel.vue?vue&type=style&index=0&id=4454a12f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454a12f",
  null
  
)

export default component.exports